<app-back-button />

<app-admin-page-title />

<app-user-management-link />

<div class="sections-container">
    <app-update-template-section />

    <app-access-report-section />

    <app-charging-report-section />

    <app-create-customers-section />

    <app-terms-updates-section *appAdminsOnlyEmailBasedAuthorize />
</div>